import axios from 'axios';
import createDataContext from './createDataContext';
import payKeyDashboardServer from '../api/payKeyDashboardServer';
import * as K from '../constants/k';
import { getSubCategoryId, kbd_success_icon } from '../utils/DictionaryManagementUtils';

const payKeyDashboardServerReducer = (state, action) => {
  switch (action.type) {
    case 'post_login':
      return action.payload;
    case 'get_me':
      return action.payload;
    case 'post_create':
      return action.payload;
    case 'post_update_by_admin':
      return action.payload;
    case 'get_all_users':
      return action.payload;
    case 'post_delete_user':
      return action.payload;
    case 'post_block_user':
      return action.payload;
    case 'post_unblock_user':
      return action.payload;
    case 'post_upload_image':
      return action.payload;
    case 'get_image':
      return action.payload;
    default:
      return state;
  }
};

//= ======================================================================

const loginUser = (dispatch) => async (username, password, callbackOk, callbackErr) => {
  try {
    const response = await payKeyDashboardServer.post('/users/login', {
      userName: username,
      password,
    });

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          const payload = {
            userDetails: response.data.userDetails,
            token: response.headers['x-auth'],
          };

          dispatch({ type: 'post_login', payload });
          if (callbackOk) callbackOk(payload);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not login, please try again...');
};

//= ======================================================================

const readMe = (dispatch) => async (token, callbackOk, callbackErr) => {
  try {
    const options = {
      headers: {
        'x-auth': token,
      },
    };

    const response = await payKeyDashboardServer.get('/users/me', options);

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({ type: 'get_me', payload: response.data.user });
          if (callbackOk) callbackOk(response.data.user);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not complete request, please try again...');
};

//= ======================================================================

const createUser = (dispatch) => async (token, userInfo, callbackOk, callbackErr) => {
  try {
    const options = {
      headers: {
        'x-auth': token,
      },
    };

    const response = await payKeyDashboardServer.post(
      '/users/create',
      {
        userName: userInfo.userUsername,
        userType: userInfo.userType,
        password: userInfo.userPassword,
      },
      options,
    );

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({ type: 'post_create', payload: response.data.userId });
          if (callbackOk) callbackOk(response.data.userId);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not create user, please try again...');
};

//= ======================================================================

const updateUserByAdmin = (dispatch) => async (token, userId, userInfo, callbackOk, callbackErr) => {
  try {
    const options = {
      headers: {
        'x-auth': token,
      },
    };

    const params = {
      userName: userInfo.userUsername,
      userType: userInfo.userType,
      password: userInfo.userPassword,
      clientName: userInfo.userInstitute,
      details: JSON.stringify({
        institute: userInfo.userInstitute,
        role: userInfo.userRole,
        fullname: userInfo.userFullname,
        email: userInfo.userEmail,
        phone: userInfo.userPhone,
      }),
      configurations: userInfo.userConfigs,
    };

    let cmd;
    if (userId === '') {
      cmd = '/users/updateMe';
    } else {
      cmd = `/users/update/${userId}`;
    }

    const response = await payKeyDashboardServer.post(cmd, params, options);

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({ type: 'post_update_by_admin', payload: response.data });
          if (callbackOk) await callbackOk(response.data.userId);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not update user, please try again...');
};

//= ======================================================================

const getAllUsers = (dispatch) => async (token, callbackOk, callbackErr) => {
  try {
    const options = {
      headers: {
        'x-auth': token,
      },
    };

    const response = await payKeyDashboardServer.get(
      '/users/allUsers',
      options,
    );

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({
            type: 'get_all_users',
            payload: response.data.allUsersDocs,
          });
          if (callbackOk) callbackOk(response.data.allUsersDocs);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not complete request, please try again...');
};

//= ======================================================================

const deleteUser = (dispatch) => async (token, userId, callbackOk, callbackErr) => {
  try {
    const options = {
      headers: {
        'x-auth': token,
      },
    };

    const response = await payKeyDashboardServer.post(
      `/users/delete/${userId}`,
      {},
      options,
    );

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({ type: 'post_delete_user', payload: response.data });
          if (callbackOk) callbackOk(response.data);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not delete user, please try again...');
};

//= ======================================================================

const blockUser = (dispatch) => async (token, userId, callbackOk, callbackErr) => {
  try {
    const options = {
      headers: {
        'x-auth': token,
      },
    };

    const response = await payKeyDashboardServer.post(
      `/users/block/${userId}`,
      {},
      options,
    );

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({ type: 'post_block_user', payload: response.data });
          if (callbackOk) callbackOk(response.data);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not block user, please try again...');
};

//= ======================================================================

const unblockUser = (dispatch) => async (token, userId, callbackOk, callbackErr) => {
  try {
    const options = {
      headers: {
        'x-auth': token,
      },
    };

    const response = await payKeyDashboardServer.post(
      `/users/unBlock/${userId}`,
      {},
      options,
    );

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({ type: 'post_unblock_user', payload: response.data });
          if (callbackOk) callbackOk(response.data);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not unblock user, please try again...');
};

//= ======================================================================

const uploadFile = (dispatch) => async (token, fileObj, fileType, callbackOk, callbackErr) => {
  try {
    const croppedFile = blobToFile(
      convertBase64ToFile(fileObj.uri, fileType),
      fileObj.name,
    );

    const formData = new FormData();
    formData.append('image', croppedFile, fileObj.name);

    const options = {
      headers: {
        'x-auth': token,
        'Content-Type': 'multipart/form-data',
        'cache-control': 'no-cache',
        Accept: 'application/json',
      },
    };

    const response = await payKeyDashboardServer.post(
      '/image/upload',
      formData,
      options,
    );

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          dispatch({ type: 'post_upload_image', payload: response.data });
          if (callbackOk) callbackOk(response.data);
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (errMsg) {
    console.log(errMsg);

    if (errMsg !== null && errMsg !== undefined) {
      if (errMsg.response !== null && errMsg.response !== undefined) {
        if (
          errMsg.response.data !== null
            && errMsg.response.data !== undefined
        ) {
          if (callbackErr) callbackErr(errMsg.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not upload file, please try again...');
};

//= ======================================================================

const addRequestIfValid = (
  requests,
  fileObjects,
  fileObj,
  isImage,
  options,
) => {
  if (
    fileObj !== null
    && fileObj !== undefined
    && fileObj.fID !== null
    && fileObj.fID !== undefined
    && fileObj.fUri === null
  ) {
    if (fileObj.fName.endsWith('.svg')) {
      fileObj = { fName: null, fUri: null, fID: null };
      return;
    }

    fileObjects.push(fileObj);

    if (isImage) {
      requests.push(
        payKeyDashboardServer.get(`/image/${fileObj.fID}`, options),
      );
    } else {
      requests.push(
        fetch(`${process.env.BACKEND_URL}/image/${fileObj.fID}`, options),
      );
    }
  }
};

const getAllFiles = (dispatch) => async (src, callbackDone) => {
  const getOptions = {
    // responseType: 'arraybuffer',
    // 'Content-Type': 'font/otf',
    headers: {
      // 'x-auth': token
      'Content-Type': 'font/otf',
      // 'Content-Type': 'image/png',
      'cache-control': 'no-cache',
    },
  };
  const requests = [];
  const fileObjects = [];
  if (!src.configurations) {
    const icons_src_list = [
      src.options.kbd_announcement_icon,
      src.options.kbd_come_back_icon,
      src.options.kbd_success_icon,
      src.options.success_image,
      src.options.keyboard_logo,
      src.options.hotkey_qab,
      src.options.keyboard_disabled_logo,
      src.options.bank_logo,
      src.options.no_results_image,
      src.options.verify_recipient_icon,
      src.options.general_error_icon,
      src.options.no_connection_icon,
      src.options.transaction_failed_icon,
      src.options.permission_to_photos_icon,
      src.options.no_landscape_icon,
      src.options.empty_state_icon,
      src.options.menu_screenshot,
      src.options.onboarding_big_stickers,
      src.options.onboarding_small_stickers,
    ];
    icons_src_list.forEach((icon_src) => addRequestIfValid(requests, fileObjects, icon_src, true, getOptions));
    src.options.select_services.value.forEach((service) => {
      if (src.options[getSubCategoryId(service)]) {
        addRequestIfValid(
          requests,
          fileObjects,
          src.options[getSubCategoryId(service)].icon,
          true,
          getOptions,
        );
        addRequestIfValid(
          requests,
          fileObjects,
          src.options[getSubCategoryId(service)].icon_action_bar,
          true,
          getOptions,
        );
      }
    });
  } else {
    const icons_src_list = [
      src.configurations.onboarding.announcement.kbd_announcement_icon,
      src.configurations.onboarding.instructions.kbd_come_back_icon,
      src.configurations.onboarding.instructions.kbd_success_icon,
      src.configurations.general.success_image,
      src.configurations.services.menu.keyboard_logo,
      src.configurations.services.menu.hotkey_qab,
      src.configurations.services.menu.keyboard_disabled_logo,
      src.configurations.services.menu.bank_logo,
      src.configurations.services.menu.iMsg_bank_logo,
      src.configurations.launch.keyboard.no_results_image,
      src.configurations.general.verify_recipient_icon,
      src.configurations.launch.error_messages.general_error_icon,
      src.configurations.launch.error_messages.no_connection_icon,
      src.configurations.launch.error_messages.transaction_failed_icon,
      src.configurations.launch.error_messages.permission_to_photos_icon,
      src.configurations.launch.error_messages.no_landscape_icon,
      src.configurations.launch.empty_state.empty_state_icon,
      src.configurations.onboarding.promotion.menu_screenshot,
      src.configurations.onboarding.promotion.onboarding_big_stickers,
      src.configurations.onboarding.promotion.onboarding_small_stickers,
    ];
    icons_src_list.forEach((icon_src) => addRequestIfValid(requests, fileObjects, icon_src, true, getOptions));
    src.configurations.services.screens_ordering.forEach((serviceKey) => {
      if (src.configurations.services[serviceKey]) {
        addRequestIfValid(
          requests,
          fileObjects,
          src.configurations.services[serviceKey].icon,
          true,
          getOptions,
        );
        addRequestIfValid(
          requests,
          fileObjects,
          src.configurations.services[serviceKey].icon_action_bar,
          true,
          getOptions,
        );
      }
    });
  }

  await axios
    .all(requests)
    .then(
      axios.spread(async (...responses) => {
        responses.forEach((response, index) => {
          if (response.data !== undefined && response.data !== null) {
            if (
              response.data.error === null
                || response.data.error === undefined
            ) {
              if (K.IMAGE_MIME_TYPE === 'image/png') {
                try {
                  fileObjects[index].fUri = `data:${K.IMAGE_MIME_TYPE};base64,${response.data}`;
                } catch (errMsg) {
                  console.log(errMsg);
                }
              } else {
                dispatch({ type: 'get_image', payload: response.data });
              }
            }
          }
        });

        // use/access the results
        if (callbackDone) await callbackDone();
      }),
    )
    .catch((errors) => {
      // react on errors.
      if (callbackDone) callbackDone();
    });
};

//= ======================================================================

const getFontFile = (dispatch) => async (fileObj, callbackDone) => {
  if (
    fileObj !== null
      && fileObj !== undefined
      && fileObj.fID !== null
      && fileObj.fID !== undefined
      && fileObj.fUri === null
  ) {
    try {
      const options = {
        // responseType: 'arraybuffer',
        // 'Content-Type': 'font/otf',
        headers: {
          // 'x-auth': token
          'Content-Type': 'font/otf',
          // 'Content-Type': 'image/png',
          'cache-control': 'no-cache',
        },
      };

      const response = await payKeyDashboardServer.get(
        `/image/${fileObj.fID}`,
        options,
      );

      if (response !== null) {
        if (response.data !== null) {
          if (
            response.data.error === null
              || response.data.error === undefined
          ) {
            dispatch({ type: 'get_image', payload: response.data });
            fileObj.fUri = `data:application/octet-stream;base64,${response.data}`;
            if (callbackDone) await callbackDone();
            return;
          }
          console.log(response.data.error);
          if (callbackDone) await callbackDone();
          return;
        }
      }
    } catch (e) {
      if (e !== null && e !== undefined) {
        if (e.response !== null && e.response !== undefined) {
          if (e.response.data !== null && e.response.data !== undefined) {
            console.log(e.response.data);
            if (callbackDone) await callbackDone();
            return;
          }
        }
      }
    }
  }
  if (callbackDone) await callbackDone();
};

//= ======================================================================

const getFile = (dispatch) => async (fileId, isImage, callbackOk, callbackErr) => {
  if (!isImage) {
    try {
      const response = await fetch(
        `${process.env.BACKEND_URL}/image/${fileId}`,
        {
          method: 'GET',
          headers: {
            // Accept: 'application/json',
            // 'Content-Type': 'application/json',
          },
        },
      );
      const responseBuffer = await response.arrayBuffer();
      dispatch({ type: 'get_image', payload: responseBuffer });
      if (callbackOk) callbackOk(responseBuffer);
      return;
    } catch (e) {
      if (e !== null && e !== undefined) {
        if (e.response !== null && e.response !== undefined) {
          if (e.response.data !== null && e.response.data !== undefined) {
            if (callbackErr) callbackErr(e.response.data.errmsg);
            return;
          }
        }
      }
    }
    if (callbackErr) callbackErr('Could not get file , please try again...');
    return;
  }

  try {
    const options = {
      // responseType: 'arraybuffer',
      // 'Content-Type': 'font/otf',
      headers: {
        // 'x-auth': token
        'Content-Type': 'font/otf',
        // 'Content-Type': 'image/png',
        'cache-control': 'no-cache',
      },
    };

    const response = await payKeyDashboardServer.get(
      `/image/${fileId}`,
      options,
    );

    if (response !== null) {
      if (response.data !== null) {
        if (
          response.data.error === null
            || response.data.error === undefined
        ) {
          if (K.IMAGE_MIME_TYPE === 'image/png') {
            const toSend = atob(response.data);
            dispatch({ type: 'get_image', payload: toSend });
            if (callbackOk) callbackOk(toSend);
          } else {
            dispatch({ type: 'get_image', payload: response.data });
            if (callbackOk) callbackOk(response.data);
          }
          return;
        }
        if (callbackErr) callbackErr(response.data.error);
        return;
      }
    }
  } catch (e) {
    if (e !== null && e !== undefined) {
      if (e.response !== null && e.response !== undefined) {
        if (e.response.data !== null && e.response.data !== undefined) {
          if (callbackErr) callbackErr(e.response.data.errmsg);
          return;
        }
      }
    }
  }

  if (callbackErr) callbackErr('Could not get file , please try again...');
};

//= ======================================================================

const blobToFile = (theBlob, fileName) => new File([theBlob], fileName, { type: theBlob.type });

const convertBase64ToFile = (image, fileType) => {
  const index = image.indexOf(',');
  if (index !== -1) {
    const byteString = image.substring(index + 1);

    const ab = new ArrayBuffer(byteString.length);

    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], {
      type: fileType,
    });
  }
  return null;
};

//= ======================================================================

export const { Context, Provider } = createDataContext(
  payKeyDashboardServerReducer,
  {
    loginUser,
    readMe,
    createUser,
    updateUserByAdmin,
    getAllUsers,
    deleteUser,
    blockUser,
    unblockUser,
    uploadFile,
    getFile,
    getAllFiles,
    getFontFile,
  },
  [],
);
